exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input[data-v-a4abccd4]{display:block;margin-bottom:10px}", ""]);

// exports
